import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="radio-button"
export default class extends Controller {
  static targets = ["input", "label"]

  select(event) {
    event.preventDefault()

    // Get the radio input from target
    if (!this.hasInputTarget) return

    const radioInput = this.inputTarget
    const radioId = radioInput.id

    // Handle toggle behavior - if already checked, uncheck it
    // This matches the original radio_status function behavior
    const check = window.$(radioInput).attr("radiotype")
    if (check == "checked") {
      radioInput.checked = false
      window.$("#" + radioId).attr("radiotype", "unchecked")
    } else {
      radioInput.checked = true
      window.$("#" + radioId).attr("radiotype", "checked")
    }

    // Uncheck all other radios in the group
    for (let i = 1; i <= 5; i++) {
      const rd = "#r" + i
      if (rd != "#" + radioId) {
        window.$(rd).attr("radiotype", "unchecked")
      }
    }

    // Call timing function if it exists
    if (typeof timing === "function") {
      timing()
    }
  }
}
